/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
import keys from "ramda/src/keys"

export enum FeatureFlagKeys {
  MVP_DISABLED,
  MVP_SINGLE_DATE_SELECTION,
  FAST_FOLLOW_DATE_RANGE,
  FAST_FOLLOW_MLM,
  FAST_FOLLOW_BE_FILTER,
  V2,
  SHOPEE_CONVERT_SIMULATE_ERROR,
  SHOPEE_VERIFY_SIMULATE_ERROR,
  FORCE_ENABLE_BULK_UPLOAD,
  MENU_STORE_SELECTOR_FORCE_VIEW_FOR_LOCAL_DEMO,
}
export const featureFlags: {
  [key in FeatureFlagKeys]?: boolean
} = {
  [FeatureFlagKeys.FAST_FOLLOW_MLM]: true,
  [FeatureFlagKeys.FAST_FOLLOW_DATE_RANGE]: false,
  [FeatureFlagKeys.MVP_DISABLED]: true,
  [FeatureFlagKeys.MVP_SINGLE_DATE_SELECTION]: true,
  [FeatureFlagKeys.FAST_FOLLOW_BE_FILTER]: false,
  [FeatureFlagKeys.SHOPEE_CONVERT_SIMULATE_ERROR]: false,
  [FeatureFlagKeys.SHOPEE_VERIFY_SIMULATE_ERROR]: false,
  [FeatureFlagKeys.FORCE_ENABLE_BULK_UPLOAD]: false,
  [FeatureFlagKeys.MENU_STORE_SELECTOR_FORCE_VIEW_FOR_LOCAL_DEMO]: false,
}

export const checkFeatureFlags = (
  conditionsChecker: {
    [key in FeatureFlagKeys]?: any
  },
  defaultVal: any = null,
) => {
  const conditions = keys<{ [key in FeatureFlagKeys]?: any }>(conditionsChecker)
  let ret = defaultVal
  for (let idx = 0; idx < conditions.length; ) {
    const condition = conditions[idx]
    if (featureFlags[condition]) {
      ret = conditionsChecker[condition]
    }
    idx += 1
  }
  if (Object.prototype.toString.apply(ret) === "[object Function]") {
    ret = ret()
  }
  return ret
}
